import { EventManager, models } from '@kurtosys/event-manager';

type EventDetail = models.EventTypeDetail;
type EventListener = models.EventListener;
type EventSource = models.EventSource;
type EventSubscription<TType extends models.EventTypes, TDetail extends EventDetail> = models.EventSubscription<TType, TDetail>;

export class GroupedEventManager {
	eventManager: EventManager | undefined;

	constructor(public groupKey: string, public sourceKey: string) {
		this.eventManager = EventManager.get();
		if (this.eventManager) {
			this.eventManager.addSource(this.groupKey);
		}
	}

	subscribe<TType extends models.EventTypes, TDetail extends EventDetail>(subscription: EventSubscription<TType, TDetail>) {
		if (this.eventManager) {
			this.eventManager.subscribe(this.groupKey, subscription);
		}
	}

	unsubscribe<TType extends models.EventTypes, TDetail extends EventDetail>(type: TType, listener: EventListener): void {
		if (this.eventManager) {
			this.eventManager.unsubscribe<TType, TDetail>(this.groupKey, type, listener);
		}
	}

	publish<TDetail extends EventDetail>(source: EventSource, detail: TDetail) {
		if (this.eventManager) {
			this.eventManager.publish(this.groupKey, {...source, groupKey: this.groupKey}, detail);
		}
	}
}